module.exports = __webpack_public_path__ + "943e88a3acfd91ff6fd07c0a48296945.png";